import { BreadcrumbProps } from "@blueprintjs/core";
import { useMapViewRoutingMetadata } from "contexts/RoutingMetadataContext";
import { useScreeningViewContext } from "contexts/ScreeningViewContext/ScreeningViewContext";
import { useSetPlatformBreadcrumbs } from "infrastructure/platform/PlatformShellContext";
import { PROSPECTING_PATH } from "infrastructure/RouterApp";
import { useEffect } from "react";
import { getLabelForRegionAndGeneratorType } from "types/generatorType";
import { getUrlForScreeningView } from "types/screeningViewType";

const ProspectingBreadcrumbs: React.FC = () => {
    const setBreadcrumbs = useSetPlatformBreadcrumbs();
    const { region, generator, urlDirectory } = useMapViewRoutingMetadata();
    const maybeScreeningViewData = useScreeningViewContext();
    const regionLabel = `${region} ${getLabelForRegionAndGeneratorType(
        region,
        generator
    )}`;

    const crumbs: ReadonlyArray<BreadcrumbProps> = [
        {
            text: "Home",
            href: `/${PROSPECTING_PATH}`
        },
        {
            text: regionLabel,
            href: `/${PROSPECTING_PATH}/${urlDirectory}`,
            current: maybeScreeningViewData === undefined
        },
        ...(maybeScreeningViewData !== undefined
            ? [
                  {
                      text: maybeScreeningViewData.title,
                      href: getUrlForScreeningView(maybeScreeningViewData),
                      current: true
                  }
              ]
            : [])
    ];

    useEffect(() => {
        setBreadcrumbs(crumbs);
        return () => setBreadcrumbs([]);
    }, [setBreadcrumbs]);

    return null;
};

export default ProspectingBreadcrumbs;
